import { useState, useMemo } from 'react';

function getVal(obj, path) {
  return path.split('.').reduce((acc, k) => acc?.[k], obj) ?? '';
}

export default function useSortable(items, defaultField = '', defaultDir = 'asc') {
  const [sort, setSort] = useState({ field: defaultField, dir: defaultDir });

  const toggle = (field) =>
    setSort(s => ({ field, dir: s.field === field ? (s.dir === 'asc' ? 'desc' : 'asc') : 'asc' }));

  const sorted = useMemo(() => {
    if (!sort.field) return items;
    return [...items].sort((a, b) => {
      const av = String(getVal(a, sort.field)).toLowerCase();
      const bv = String(getVal(b, sort.field)).toLowerCase();
      const cmp = av.localeCompare(bv, 'pt-BR', { numeric: true });
      return sort.dir === 'asc' ? cmp : -cmp;
    });
  }, [items, sort.field, sort.dir]);

  const Th = ({ field, children, className = '' }) => (
    <th
      className={`${className}`}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}
      onClick={() => toggle(field)}
    >
      {children}
      {sort.field === field
        ? <i className={`bi bi-sort-${sort.dir === 'asc' ? 'up' : 'down'}-alt ms-1 small`} style={{ color: 'var(--main-color)' }}></i>
        : <i className="bi bi-arrow-down-up ms-1 opacity-25 small"></i>
      }
    </th>
  );

  return { sorted, sort, toggle, Th };
}
